import { writable } from "svelte/store";
import { get } from "svelte/store";
function fetch_nostric_events() {
    const nostric_events = writable([]);
    const { subscribe, update, set } = nostric_events;
    const add = (nostric_event) => update((events) => {
        let nostric_event_id = nostric_event.event.id;
        if (!events.find((past_event) => past_event.event.id === nostric_event_id)) {
            events = events.concat(nostric_event);
            events.sort((x, y) => y.event.created_at - x.event.created_at);
        }
        return events;
    });
    const find = (event_id) => get(nostric_events).find((nostric_event) => nostric_event.event.id == event_id);
    const clear = () => set([]);
    return {
        subscribe,
        add,
        clear,
        find,
    };
}
export const nostric_events = fetch_nostric_events();
export const nostric_relays_count = writable(0);
export const nostric_relays_eose_count = writable(0);
function fetch_nostric_user_encounters() {
    const users = writable([]);
    const { subscribe, update, set } = users;
    const find_user = (hexpub) => {
        return get(users).find((followee) => followee.hexpubkey() === hexpub);
    };
    const add_user = (new_user) => update((nostric_users) => {
        let new_hexpubkey = new_user.hexpubkey();
        if (!nostric_users.find((user) => user.hexpubkey() === new_hexpubkey)) {
            nostric_users = nostric_users.concat(new_user);
        }
        return nostric_users;
    });
    const remove_user = (user) => update((nostric_users) => {
        let new_hexpubkey = user.hexpubkey();
        return nostric_users.filter((user) => user.hexpubkey() !== new_hexpubkey);
    });
    const clear = () => set([]);
    return {
        subscribe,
        find_user,
        add_user,
        remove_user,
        clear,
    };
}
export const nostric_users = fetch_nostric_user_encounters();
export var STATUS;
(function (STATUS) {
    STATUS[STATUS["OPEN"] = 0] = "OPEN";
    STATUS[STATUS["CLOSED"] = 1] = "CLOSED";
    STATUS[STATUS["ERROR"] = 2] = "ERROR";
})(STATUS || (STATUS = {}));
function fetch_nostric_relay_statuses() {
    const relays = writable([]);
    const { subscribe, update, set } = relays;
    const find = (relays, gateway_url, canister_id) => relays.findIndex((relay) => relay.gateway_url === gateway_url && relay.canister_id === canister_id);
    const get_status = (gateway_url, canister_id) => {
        let all_relays = get(relays);
        let index = find(all_relays, gateway_url, canister_id);
        return all_relays[index];
    };
    const set_status = (gateway_url, canister_id, status) => update((relays) => {
        let index = find(relays, gateway_url, canister_id);
        if (index !== -1) {
            relays[index].status = status;
            return relays;
        }
        else {
            return [...relays, { gateway_url, canister_id, status }];
        }
    });
    const remove_relay = (gateway_url, canister_id) => update((relays) => relays.filter((relay) => relay.gateway_url !== gateway_url && relay.canister_id !== canister_id));
    const clear = () => set([]);
    return {
        subscribe,
        get_status,
        set_status,
        remove_relay,
        clear,
    };
}
export const relay_statuses = fetch_nostric_relay_statuses();
